package com.binayshaw7777.myportfolio.components.sections

import androidx.compose.runtime.Composable
import com.binayshaw7777.myportfolio.*
import com.binayshaw7777.myportfolio.components.widgets.CursorMode
import com.binayshaw7777.myportfolio.components.widgets.LocalCursorMode
import com.binayshaw7777.myportfolio.components.widgets.changeCursorMode
import com.binayshaw7777.myportfolio.utils.Constants
import com.binayshaw7777.myportfolio.utils.Res
import com.binayshaw7777.myportfolio.utils.Strings
import com.binayshaw7777.myportfolio.widgets.AppearanceAwareImage
import com.binayshaw7777.myportfolio.widgets.StrokeChips
import com.varabyte.kobweb.compose.css.FontOpticalSizing
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

@Composable
fun Project() {
    val pageContext = rememberPageContext()
    val breakpoint = rememberBreakpoint()

    Column(
        modifier = Modifier.fillMaxSize().fontFamily(Constants.SYNE).margin(top = 100.px).margin(bottom = 25.vh).id("projects"),
    ) {

        RevealSpanOnVisible(threshold = 0.95) { visible, ref ->
            SpanText(
                text = "Works",
                modifier = SectionTitleFontStyle.toModifier()
                    .then(if (visible) Modifier.revealText(durationMs = 900) else Modifier),
                ref = ref
            )
        }

        HorizontalDivider()

        // /01 KotStep
        Row(
            modifier = KotStepDivStyle.toModifier().fillMaxWidth()
                .margin(topBottom = 75.px)
                .changeCursorMode("View KotStep")
                .onClick {
                    pageContext.router.navigateTo(Constants.KOTSTEP_URL)
                },
            horizontalArrangement = Arrangement.SpaceAround,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Column(
                modifier = Modifier.maxWidth(75.percent)
                    .margin(topBottom = 20.px, leftRight = 15.px),
                verticalArrangement = Arrangement.SpaceAround
            ) {
                SpanText(
                    text = Strings.KOTSTEP,
                    modifier = Modifier.fontSize(60.px).fontWeight(FontWeight.Bold)
                )
                SpanText(
                    text = Strings.KOTSTEP_DESCRIPTION,
                    modifier = Modifier
                        .fontSize(18.px)
                        .margin(topBottom = 10.px)
                        .fontWeight(401)
                        .fontOpticalSizing(FontOpticalSizing.Auto)
                )
                Row(
                    modifier = Modifier.margin(top = 2.cssRem)
                        .display(DisplayStyle.Flex).flexWrap(FlexWrap.Wrap),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    StrokeChips(modifier = Modifier.margin(right = 0.8.cssRem, top = 0.4.cssRem, bottom = 0.4.cssRem), text = Strings.KOTLIN)
                    StrokeChips(modifier = Modifier.margin(right = 0.8.cssRem, top = 0.4.cssRem, bottom = 0.4.cssRem), text = Strings.JETPACK_COMPOSE)
                    StrokeChips(modifier = Modifier.margin(right = 0.8.cssRem, top = 0.4.cssRem, bottom = 0.4.cssRem), text = Strings.ANDROID)
                }
            }
            if (breakpoint >= Breakpoint.MD) {
                Spacer()
                SpanText("/01", modifier = Modifier.fontSize(40.px).fontWeight(FontWeight.Bold))
                Div(attrs = Modifier.id("kotstep").toAttrs()) {
                    AppearanceAwareImage(src = Res.CURVED_HEAD_ARROW, modifier = Modifier.size(40.px).margin(all = 20.px))
                }
            }
        }

        HorizontalDivider()

        /*
        // /02 LeafleKT
        Row(
            modifier = LeafleKTDivStyle.toModifier().fillMaxWidth()
                .margin(topBottom = 75.px)
                .changeCursorMode("View LeafleKT")
                .onClick {
                    pageContext.router.navigateTo(Constants.LEAFLEKT_URL)
                },
            horizontalArrangement = Arrangement.SpaceAround,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Column(
                modifier = Modifier.maxWidth(75.percent)
                    .margin(topBottom = 20.px, leftRight = 15.px),
                verticalArrangement = Arrangement.SpaceAround
            ) {
                SpanText(
                    text = Strings.LEAFLEKT,
                    modifier = Modifier.fontSize(60.px).fontWeight(FontWeight.Bold)
                )
                SpanText(
                    text = Strings.LEAFLEKT_DESCRIPTION,
                    modifier = Modifier
                        .fontSize(18.px)
                        .margin(topBottom = 10.px)
                        .fontWeight(401)
                        .fontOpticalSizing(FontOpticalSizing.Auto)
                )
                Row(
                    modifier = Modifier.margin(top = 2.cssRem)
                        .display(DisplayStyle.Flex).flexWrap(FlexWrap.Wrap),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    StrokeChips(modifier = Modifier.margin(right = 0.8.cssRem, top = 0.4.cssRem, bottom = 0.4.cssRem), text = Strings.KOTLIN)
                    StrokeChips(modifier = Modifier.margin(right = 0.8.cssRem, top = 0.4.cssRem, bottom = 0.4.cssRem), text = Strings.KMP)
                    StrokeChips(modifier = Modifier.margin(right = 0.8.cssRem, top = 0.4.cssRem, bottom = 0.4.cssRem), text = Strings.LEAFLET_JS)
                }
            }
            if (breakpoint >= Breakpoint.MD) {
                Spacer()
                SpanText("/02", modifier = Modifier.fontSize(40.px).fontWeight(FontWeight.Bold))
                Div(attrs = Modifier.id("leaflekt").toAttrs()) {
                    AppearanceAwareImage(src = Res.CURVED_HEAD_ARROW, modifier = Modifier.size(40.px).margin(all = 20.px))
                }
            }
        }

        HorizontalDivider()
        */

        // /02 JusTap
        Row(
            modifier = JusTapDivStyle.toModifier().fillMaxWidth()
                .margin(topBottom = 75.px)
                .changeCursorMode("View Justap")
                .onClick {
                    pageContext.router.navigateTo(Constants.JUSTAP_URL)
                },
            horizontalArrangement = Arrangement.SpaceAround,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Column(
                modifier = Modifier.maxWidth(75.percent)
                    .margin(topBottom = 20.px, leftRight = 15.px),
                verticalArrangement = Arrangement.SpaceAround
            ) {
                SpanText(
                    text = Strings.JUSTAP,
                    modifier = Modifier.fontSize(60.px).fontWeight(FontWeight.Bold)
                )
                SpanText(
                    text = Strings.JUSTAP_DESCRIPTION,
                    modifier = Modifier
                        .fontSize(18.px)
                        .margin(topBottom = 10.px)
                        .fontWeight(401)
                        .fontOpticalSizing(FontOpticalSizing.Auto)
                )
                Row(
                    modifier = Modifier.margin(top = 2.cssRem)
                        .display(DisplayStyle.Flex).flexWrap(FlexWrap.Wrap),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    StrokeChips(modifier = Modifier.margin(right = 0.8.cssRem, top = 0.4.cssRem, bottom = 0.4.cssRem), text = Strings.KOTLIN)
                    StrokeChips(modifier = Modifier.margin(right = 0.8.cssRem, top = 0.4.cssRem, bottom = 0.4.cssRem), text = Strings.JETPACK_COMPOSE)
                    StrokeChips(modifier = Modifier.margin(right = 0.8.cssRem, top = 0.4.cssRem, bottom = 0.4.cssRem), text = Strings.FIREBASE)
                }
            }
            if (breakpoint >= Breakpoint.MD) {
                Spacer()
                SpanText("/02", modifier = Modifier.fontSize(40.px).fontWeight(FontWeight.Bold))
                Div(attrs = Modifier.id("justap").toAttrs()) {
                    AppearanceAwareImage(src = Res.CURVED_HEAD_ARROW, modifier = Modifier.size(40.px).margin(all = 20.px))
                }
            }
        }

        HorizontalDivider()

        // /03 ReadBud
        Row(
            modifier = ReadBudDivStyle.toModifier().fillMaxWidth()
                .margin(topBottom = 75.px)
                .changeCursorMode("View Readbud")
                .onClick {
                    pageContext.router.navigateTo(Constants.READBUD_URL)
                },
            horizontalArrangement = Arrangement.SpaceAround,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Column(
                modifier = Modifier.maxWidth(75.percent)
                    .margin(topBottom = 20.px, leftRight = 15.px),
                verticalArrangement = Arrangement.SpaceAround
            ) {
                SpanText(
                    text = Strings.READBUD,
                    modifier = Modifier.fontSize(60.px).fontWeight(FontWeight.Bold)
                )
                SpanText(
                    text = Strings.READBUD_DESCRIPTION,
                    modifier = Modifier
                        .fontSize(18.px)
                        .margin(topBottom = 10.px)
                        .fontWeight(401)
                        .fontOpticalSizing(FontOpticalSizing.Auto)
                )
                Row(
                    modifier = Modifier.margin(top = 2.cssRem)
                        .display(DisplayStyle.Flex).flexWrap(FlexWrap.Wrap),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    StrokeChips(modifier = Modifier.margin(right = 0.8.cssRem, top = 0.4.cssRem, bottom = 0.4.cssRem), text = Strings.KOTLIN)
                    StrokeChips(modifier = Modifier.margin(right = 0.8.cssRem, top = 0.4.cssRem, bottom = 0.4.cssRem), text = Strings.JETPACK_COMPOSE)
                    StrokeChips(modifier = Modifier.margin(right = 0.8.cssRem, top = 0.4.cssRem, bottom = 0.4.cssRem), text = Strings.ML_KIT)
                }
            }
            if (breakpoint >= Breakpoint.MD) {
                Spacer()
                SpanText("/03", modifier = Modifier.fontSize(40.px).fontWeight(FontWeight.Bold))
                Div(attrs = Modifier.id("readbud").toAttrs()) {
                    AppearanceAwareImage(src = Res.CURVED_HEAD_ARROW, modifier = Modifier.size(40.px).margin(all = 20.px))
                }
            }
        }

        HorizontalDivider()
    }

}
